import { render, staticRenderFns } from "./Posicion.vue?vue&type=template&id=22043408&"
import script from "./Posicion.vue?vue&type=script&lang=js&"
export * from "./Posicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports